import React from "react"

export type ID24FeatureToggle = {
  organizationSettings: boolean
  adfsLogin: boolean
}

type Props = {
  children: React.ReactNode
  featureToggle: ID24FeatureToggle
}

const FeatureToggleContext = React.createContext<ID24FeatureToggle>({ organizationSettings: false, adfsLogin: false })

export const FeatureToggleProvider: React.FC<Props> = ({children, featureToggle}): React.ReactElement =>
  <FeatureToggleContext.Provider value={featureToggle}>
    {children}
  </FeatureToggleContext.Provider>

export const useFeatureToggle = () => React.useContext(FeatureToggleContext)